import {IAppRoute} from "../../application/config/IAppRoute";
import {routeListUsers} from "./routeListUsers";
import {routeUserEdit} from "./routeUserEdit";

export const routesUserManagement: IAppRoute<any>[] = [
  routeListUsers,
  routeUserEdit,
];
